import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface FileUploadData {
  title: string,
  buttonText: string,
  isBatch?: boolean,
  isFromDirectory?: boolean,
  fileValidators?: ValidatorFn[],
  allowedFiles?: string[],
  inputFields?: {
    label: string;
    key: string;
    form: FormControl;
    type: string;
  }[];
}

@Component({
  selector: 'lib-av-file-upload',
  templateUrl: './av-file-upload.component.html',
  styleUrls: ['./av-file-upload.component.scss']
})
export class AvFileUploadComponent implements OnInit {
  file: FormControl = new FormControl(undefined, [Validators.required, ...(this.data.fileValidators ?? [])]);

  constructor(
    public dialogRef: MatDialogRef<AvFileUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileUploadData
  ) { }

  onFileSelected(files: File[] | FileList) {
    this.file.setValue(this.data.isBatch ? files : files[0]);
    this.file.markAsTouched();
  }

  save() {
    const output = this.data.inputFields?.reduce((acc, field) => {
      acc[field.key] = field.form.value;
      return acc;
    }, {}) ?? {};
    output['file'] = this.file.value;
    this.dialogRef.close(output);
  }

  ngOnInit(): void {
  }

}
